import { ProductModel } from './models/product.js';

class ProductRegistration {
  constructor() { }

  parseDashboardData(data) {
    const rawData = JSON.parse(JSON.stringify(data));
    const mappedData = [];

    rawData.forEach((item) => {
      const productInformation = {
        ...item.productInformation,
        ...item.productInformation.basicInformation,
        ...item.productInformation.extendedInformation
      };

      delete productInformation.basicInformation;
      productInformation.creationDate = item.metaData.creationDateTime;
      const variantIndexList = item.productPackagingHierarchy.map((item, i) => {
        return i
      });

      mappedData.push({
        logisticsComplete: item.metaData.logisticsComplete,
        publicationComplete: item.metaData.publicationComplete,
        transactionId: item._id,
        metaData: item.metaData,
        variantIndexList,
        userId: item.metaData.userId,
        informationProvider: item.metaData.informationProvider,
        productInformation,
        productPackagingHierarchy: [...item.productPackagingHierarchy],
        logisticsInformation: item.logisticsInformation,
        publicationInformation: item.publicationInformation
      });
    });

    return mappedData;
  }

  parseMarketingData(data) {
    const rawData = JSON.parse(JSON.stringify(data));
    const mappedData = [];

    rawData.forEach((item) => {
      const productInformation = {
        ...item.productInformation,
        ...item.productInformation.basicInformation,
        ...item.productInformation.extendedInformation
      };
      const marketingInformation = { ...item.marketingInformation };

      delete productInformation.basicInformation;

      productInformation.creationDate = item.metaData.creationDateTime;

      mappedData.push({
        transactionId: item._id,
        userId: item.metaData.userId,
        informationProvider: item.metaData.informationProvider,
        productInformation,
        publicationInformation: item.publicationInformation,
        uniqueSellingPoints: marketingInformation.uniqueSellingPoints,
        description: marketingInformation.description,
        keywords: marketingInformation.keywords
      });
    });

    return mappedData;
  }


  parseHistoryData(data) {
    const rawData = JSON.parse(JSON.stringify(data));
    const mappedData = [];

    rawData.forEach((item) => {
      const productInformation = {
        ...item.productInformation,
        ...item.productInformation.basicInformation,
        ...item.productInformation.extendedInformation
      };

      delete productInformation.basicInformation;
      productInformation.creationDate = item.metaData.creationDateTime;
      const variantIndexList = item.productPackagingHierarchy.map((item, i) => {
        return i
      });

      mappedData.push({
        logisticsComplete: item.metaData.logisticsComplete,
        publicationComplete: item.metaData.publicationComplete,
        transactionId: item._id,
        metaData: item.metaData,
        variantIndexList,
        userId: item.metaData.userId,
        informationProvider: item.metaData.informationProvider,
        productInformation,
        productPackagingHierarchy: [...item.productPackagingHierarchy],
        logisticsInformation: item.logisticsInformation,
        publicationInformation: item.publicationInformation
      });
    });

    return mappedData;
  }

  mapping(data) {
    const rawData = JSON.parse(JSON.stringify(data));

    const mappedList = rawData.map((item) => {
      const mappedItem = new ProductModel(item);
      return mappedItem;
    });

    return mappedList;
  }
}

export default new ProductRegistration();
